import PropTypes from 'prop-types';
import cn from 'classnames';

import arrow from 'assets/arrow.svg';

import styles from './styles.module.scss';

// Flow selection categories and options
const GENERAL_OPTIONS = [
  {
    id: 'ux_critique',
    title: 'Growth Audit',
    description: 'Find what\'s causing friction, how to fix it and boost engagement',
    emoji: '🧠',
  },
  {
    id: 'new_ideas',
    title: 'New Ideas & Prototypes',
    description: 'Strategic growth ideas with ready-to-test prototypes and A/B variants',
    emoji: '💡',
  },
];

const POPULAR_FLOWS = [
  {
    id: 'signup',
    title: 'Signup',
    description: 'Reduce drop-offs and remove friction in the signup process',
    emoji: '📝',
  },
  {
    id: 'onboarding_flow',
    title: 'User Onboarding',
    description: 'Help users reach the Aha moment faster and drive higher activation',
    emoji: '🎯',
  },
  {
    id: 'upgrade_pricing',
    title: 'Upgrade & Pricing',
    description: 'Convert free users to paid plans by streamlining upgrade flows',
    emoji: '🏆',
  },
  {
    id: 'checkout_payment',
    title: 'Checkout & Payment',
    description: 'Simplify the purchase journey to increase conversion rates',
    emoji: '🛒',
  },
];

const FlowSelection = ({
  selectedFlow,
  onFlowSelect,
  onNext,
  className,
}) => {
  const handleFlowSelect = flowId => {
    onFlowSelect(flowId);
  };

  const handleNext = () => {
    if (selectedFlow && onNext) {
      onNext();
    }
  };

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.content}>
        {/* Header */}
        <div className={styles.header}>
          <h1 className={styles.title}>
            Select your review
          </h1>
        </div>

        {/* Review Types Section */}
        <div className={styles.reviewTypes}>
          {/* General Section */}
          <div className={styles.section}>
            <h2 className={styles.sectionLabel}>
              All flows
            </h2>
            <div className={styles.options}>
              {GENERAL_OPTIONS.map(option => (
                <button
                  key={option.id}
                  className={cn(styles.card, {
                    [styles.cardSelected]: selectedFlow === option.id,
                  })}
                  onClick={() => handleFlowSelect(option.id)}
                >
                  <div className={styles.cardTitle}>
                    <span className={styles.cardEmoji}>
                      {option.emoji}
                    </span>
                    <span className={styles.cardTitleText}>
                      {option.title}
                    </span>
                  </div>
                  <div className={styles.cardDescription}>
                    {option.description}
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className={styles.reviewTypes}>
          {/* General Section */}
          <div className={styles.section}>
            <h2 className={styles.sectionLabel}>
              Popular flows
            </h2>
            <div className={styles.options}>
              {POPULAR_FLOWS.map(option => (
                <button
                  key={option.id}
                  className={cn(styles.card, {
                    [styles.cardSelected]: selectedFlow === option.id,
                  })}
                  onClick={() => handleFlowSelect(option.id)}
                >
                  <div className={styles.cardTitle}>
                    <span className={styles.cardEmoji}>
                      {option.emoji}
                    </span>
                    <span className={styles.cardTitleText}>
                      {option.title}
                    </span>
                  </div>
                  <div className={styles.cardDescription}>
                    {option.description}
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className={styles.footer}>
        <div className={styles.buttons}>
          <button
            className={cn(styles.button, styles.buttonNext, {
              [styles.buttonDisabled]: !selectedFlow,
            })}
            onClick={handleNext}
            disabled={!selectedFlow}
          >
            Upload your screens
            <img src={arrow} />
          </button>
        </div>
      </div>
    </div>
  );
};

FlowSelection.propTypes = {
  selectedFlow: PropTypes.string,
  onFlowSelect: PropTypes.func.isRequired,
  onNext: PropTypes.func,
  className: PropTypes.string,
};

FlowSelection.defaultProps = {
  selectedFlow: null,
  onNext: null,
  className: '',
};

export default FlowSelection;
